
import entities from './entities'
export default function () {
  return {
    entities
  }
}
